import * as React from "react"

import { EmailPreferenceCenterEntry } from "../bootstrap"
import Feedback from "../Feedback"
import { getEmailPreferenceCenterTranslation } from "../i18n"
import usePreferenceCenter from "./hooks/usePreferenceCenter"
import ChannelPreferenceCenter from "./ChannelPreferenceCenter"
import ContactPreferenceCenter from "./ContactPreferenceCenter"

import "./styles/index.pcss"

const PreferenceCenterWrapper: React.FC<EmailPreferenceCenterEntry> = (
  entry
) => {
  const translation = getEmailPreferenceCenterTranslation(entry.i18n ?? {})
  const state = usePreferenceCenter(entry)

  if (state.status === "error")
    return <Feedback>{translation.errorLoadingPreferenceCenter}</Feedback>

  return state.status === "loading" ? (
    <>{translation.loading}</>
  ) : (
    <div className="preference-center">
      {!state.isContactPreferenceCenter ? (
        <ChannelPreferenceCenter
          channelId={state.channelId}
          preferenceCenter={state.preferenceCenter}
          translation={translation}
          entry={entry}
          unsubscribe={state.unsubscribe}
        />
      ) : (
        <ContactPreferenceCenter
          contactId={state.contactId}
          channelId={state.channelId}
          deviceType={state.deviceType}
          preferenceCenter={state.preferenceCenter}
          translation={translation}
          entry={entry}
          unsubscribe={state.unsubscribe}
        />
      )}
    </div>
  )
}

export default PreferenceCenterWrapper
